import * as React from 'react';

/**
 * Pending SVG component
 *
 * @returns
 */
function ExclamationCircleSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 32 32"
			className={'icon icon-exclamation-circle ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
		>
			<path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16v0c0-8.837-7.163-16-16-16v0zM16 25.077c-1.019 0-1.845-0.826-1.845-1.845s0.826-1.845 1.845-1.845c1.019 0 1.845 0.826 1.845 1.845v0c0 1.019-0.826 1.845-1.845 1.845v0zM17.845 17.077c0 1.020-0.827 1.846-1.846 1.846s-1.846-0.827-1.846-1.846v0-8.617c0-1.020 0.827-1.846 1.846-1.846s1.846 0.827 1.846 1.846v0z" />
		</svg>
	);
}

ExclamationCircleSVG.defaultProps = { class: '' };

export default ExclamationCircleSVG;
